import React, { useState } from "react";
import { Offcanvas, Form, Alert, Spinner, Badge } from "react-bootstrap";
import { FaDownload, FaFileCsv, FaFileExcel, FaFilePdf } from "react-icons/fa";

const ReportExport = ({ Show, Hide, Title, reportData, onConfirm }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [formData, setFormData] = useState({
    format: "csv",
    includeHeader: true,
    includeTimestamp: true,
  });

  const formats = [
    { value: "csv", label: "CSV", icon: <FaFileCsv /> },
    { value: "excel", label: "Excel", icon: <FaFileExcel /> },
    { value: "pdf", label: "PDF", icon: <FaFilePdf /> },
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = () => {
    setButtonLoader(true);
    setTimeout(() => {
      setButtonLoader(false);
      if (onConfirm) onConfirm(formData.format);
      Hide();
    }, 1500);
  };

  const report = reportData || {
    name: "Enrollment Report",
    id: "enrollment",
    description: "Screened, randomized and status by site",
    category: "Subject",
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="md">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title || `Export — ${report.name}`}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Alert variant="info" className="d-flex align-items-start gap-2 py-2">
          <span>ℹ</span>
          <div style={{ fontSize: "13px" }}>
            Export the report in your preferred format. The export will include all current data.
          </div>
        </Alert>

        <div className="mb-4">
          <div className="mb-2">
            <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "600" }}>
              Report
            </span>
          </div>
          <div className="p-2 bg-light rounded border">
            <div className="fw-semibold">{report.name}</div>
            <div className="text-muted small">{report.description}</div>
            <Badge className={`bg-${report.category === "Subject" ? "primary" : 
              report.category === "Inventory" ? "success" : 
              report.category === "Supply Chain" ? "warning" : 
              report.category === "Safety" ? "danger" : "info"} mt-1`}>
              {report.category}
            </Badge>
          </div>
        </div>

        <hr className="my-3" />

        <div className="mb-3">
          <div className="mb-2">
            <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "600" }}>
              Export Format <span className="text-danger">*</span>
            </span>
          </div>
          <div className="d-flex gap-2">
            {formats.map((fmt) => (
              <button
                key={fmt.value}
                className={`${formData.format === fmt.value ? "updateProfile activee" : "updateProfile"} hstack gap-1`}
                onClick={() => setFormData(prev => ({ ...prev, format: fmt.value }))}
              >
                {fmt.icon}
                {fmt.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-3">
          <div className="mb-2">
            <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "600" }}>
              Export Options
            </span>
          </div>
          <Form.Check
            type="checkbox"
            id="export-header"
            name="includeHeader"
            checked={formData.includeHeader}
            onChange={handleInputChange}
            label="Include column headers"
            className="mb-2"
          />
          <Form.Check
            type="checkbox"
            id="export-timestamp"
            name="includeTimestamp"
            checked={formData.includeTimestamp}
            onChange={handleInputChange}
            label="Include timestamp in filename"
          />
        </div>

        {formData.format === "pdf" && (
          <div className="p-2 bg-light rounded small text-muted">
            <FaFilePdf className="me-1" />
            PDF export will include all columns and formatting for print-ready reports.
          </div>
        )}

        {formData.format === "excel" && (
          <div className="p-2 bg-light rounded small text-muted">
            <FaFileExcel className="me-1" />
            Excel export includes all data with proper formatting for analysis.
          </div>
        )}

        {formData.format === "csv" && (
          <div className="p-2 bg-light rounded small text-muted">
            <FaFileCsv className="me-1" />
            CSV export is compatible with most data analysis tools and spreadsheets.
          </div>
        )}
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top d-flex justify-content-end gap-2">
        <button
          onClick={handleSubmit}
          className="updateProfile"
          disabled={buttonLoader}
        >
          {buttonLoader ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner size="sm" animation="border" variant="light" />
              <span>Exporting...</span>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <FaDownload />
              Export
            </div>
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default ReportExport;